import { Box, Stack, Typography } from "@mui/material";

import { ChemistryRow } from "../../report/models/ChemistryRow";
import {
	getSupplierColor,
	getSupplierInitial,
} from "@/shared/utils/supplierColors";

export const SupplierLegend = ({ rows }: { rows: ChemistryRow[] }) => {
	const suppliers = Array.from(
		new Set(rows.map((row) => row.Supplier).filter(Boolean) as string[]),
	).sort();

	if (suppliers.length === 0) return null;

	return (
		<Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
			{suppliers.map((supplier) => (
				<Stack key={supplier} direction="row" spacing={0.5} alignItems="center">
					<Box
						sx={{
							width: 16,
							height: 16,
							borderRadius: 0.75,
							bgcolor: getSupplierColor(supplier),
							color: "#fff",
							fontSize: "0.6rem",
							fontWeight: 700,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						{getSupplierInitial(supplier)}
					</Box>
					<Typography variant="caption" color="text.secondary">
						{supplier}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
};
